import Image from "next/image";
import styles from "./faculty-list.module.css";
import shankar from "../../assets/images/faculty/D.Shankar.webp";
import vaishnavi from "../../assets/images/faculty/s.d.vaishnavi.webp";
import chandraSekar from "../../assets/images/faculty/ChandraSekar1.webp";
import shivashankarp from "../../assets/images/faculty/shivashankar-p.webp";
import RajithaShivashankar1 from "../../assets/images/faculty/Rajitha-Shivashankar-1.webp";
import Sakthya from "../../assets/images/faculty/Sakthya.webp";
import KMPathi from "../../assets/images/faculty/K-M-Pathi.webp";
import Dnilango from "../../assets/images/faculty/Dnilango.png";
import GaneshVK1 from "../../assets/images/faculty/Ganesh-V.K-1.webp";
import ManikandanSR1 from "../../assets/images/faculty/Manikandan-S.R-1.webp";
import Govindaraju1 from "../../assets/images/faculty/Govindaraju-1.webp";
import SaravanaMoorthy1 from "../../assets/images/faculty/Saravana-moorthy-sir.png";
import vijayprofile from "../../assets/images/faculty/vijay-profile.webp";
import Gowtham from "../../assets/images/faculty/Gowtham.webp";
import VittalReddy from "../../assets/images/faculty/Vittal-Reddy.webp";
import DArunKumar1 from "../../assets/images/faculty/D.Arun-Kumar-1.webp";
import SobhanGeorge from "../../assets/images/faculty/SobhanGeorge.png";
import Sarath from "../../assets/images/faculty/Sarath.webp";
import Kanagaraj from "../../assets/images/faculty/Kanagaraj.webp";
import KarthikeyanS from "../../assets/images/faculty/Karthikeyan-S.webp";
import Mowshmikka from "../../assets/images/faculty/Mowshmikka.webp";
import profileplaceholder from "../../assets/images/faculty/profile-placeholder.png";
import ArjunRadhakrishnan from "../../assets/images/faculty/Arjun-Radhakrishnan.webp";
import Chandramohan from "../../assets/images/faculty/Chandramohan.webp";
import premanand from "../../assets/images/faculty/premanand.webp";
import eshwar from "../../assets/images/faculty/eshwar.png";
import sucharithan from "../../assets/images/faculty/sucharithan.webp";
import rajkumarsp from "../../assets/images/faculty/rajkumarsp.webp";
import NithyaSelvakumar from "../../assets/images/faculty/NithyaSelvakumar.webp";
import SivaChidambaram from "../../assets/images/faculty/SivaChidambaram.webp";
import Alokkumar from "../../assets/images/faculty/Mr-Alok-Kumar-Pathak.webp";
import Mukuljha from "../../assets/images/faculty/Mr-Mukul-Jha.webp";
import Ruchir from "../../assets/images/faculty/Mr-Ruchi-kumar.webp";
import shahnawaz from "../../assets/images/faculty/Mr-Shahnawaz.webp";
import venkataramanan from "../../assets/images/faculty/Mr-Venkataramanan-S.png";
import AbuMathew from  "../../assets/images/faculty/M-AbuMathew.png";
import AkkemSomasekhar from  "../../assets/images/faculty/Akkem-Somasekhar.png";
import Arunkumar from "../../assets/images/faculty/Arunkumar.png";
import Ganeshkumar from "../../assets/images/faculty/Ganeshkumar.png";
import KarthikeyanP from "../../assets/images/faculty/KarthikeyanP.png";
import SammratBhaskar from "../../assets/images/faculty/SammratBhaskar.png";
import Vishnu from "../../assets/images/faculty/Vishnu.png";
import Anusha from "../../assets/images/faculty/Anusha.png";
import JohnMajel from "../../assets/images/faculty/JohnMajel.png";
import Vishwas from "../../assets/images/faculty/Vishwas.png";
import Sandeep from "../../assets/images/faculty/sandeepH.png";
import Elanchezhiyan from "../../assets/images/faculty/Elanchezhiyan.png";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import Link from "next/link";
import Head from "next/head";
const Faculty = () => {
 
  return (
    <>
               <Head>
                <meta charset="UTF-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="robots" content="noodp,noydir" />
                <meta name="robots" content="index,follow" />
                <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
                <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
                <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
                <title>Our Faculty | Shankar IAS Academy</title>
                <meta name="title" content="Our Faculty | Shankar IAS Academy" />
                <meta name="description" content="Meet the brilliance at Shankar IAS Academy. Expert Faculty dedicated to your UPSC success. Elevate your learning experience with exceptional guidance." />
                <link rel="canonical" href="https://www.shankariasacademy.com/our-faculty/" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="Our Faculty | Shankar IAS Academy" />
                <meta property="og:description" content="Meet the brilliance at Shankar IAS Academy. Expert Faculty dedicated to your UPSC success. Elevate your learning experience with exceptional guidance." />
                <meta property="og:url" content="https://www.shankariasacademy.com/our-faculty/" />
                <meta property="og:site_name" content="Shankar IAS Academy" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@shankarias" />
              </Head>

      <Navbar title="about" />
      {/* // <!-- UPSC Class Online --> */}
     
      <div className="container">
        <div className="row">
          <div className="col pt-3 pt-md-4">
            <h1 className={`${styles.pagemaintitle}`}>Our Faculty Team</h1>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row">
          <div className="col">
            <div
              className={`${styles.tabscrollclass} nav nav-pills mb-3  align-items-baseline`}
            >
              <Link href="/our-faculty">
                <button
                  id={styles.tablinks}
                  className="nav-link tab1 py-2 px-0 me-4 active"
                  type="button"
                >
                  UPSC Faculty
                </button>
              </Link>
             
              {/*<Link href="/visiting-faculty-panel-members">
                <button
                  id={styles.tablinks}
                  className="nav-link tab2 py-2 px-0 me-4 "
                  type="button"
                >
                  UPSC - Visiting UPSC Faculty
                </button> 
              </Link> */}
              
              <Link href="/tnpsc-faculty-list">
                <button
                  id={styles.tablinks}
                  className="nav-link py-2 px-0 me-4"
                  type="button"
                >
                  TNPSC Faculty
                </button>
              </Link>
              <Link href="/bankingssc-faculty-list">
                <button
                  id={styles.tablinks}
                  className="nav-link py-2 px-0 me-4"
                  type="button"
                >
                  Banking & SSC Faculty
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
      

      <div className="container">
            <div className="row">
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder1} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={shankar}
                      alt="Mr. Shankar Devarajan"
                      className="img-fluid"
                      title="Mr. Shankar Devarajan"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mr. Shankar Devarajan
                    </p>
                    <p className={`${styles.acheiverrank} mb-2`}>Founder</p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder2} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={vaishnavi}
                      alt=" Dr. Vaishnavi S D"
                      className="img-fluid"
                      title=" Dr. Vaishnavi S D"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Dr. Vaishnavi S D
                    </p>
                    <p className={`${styles.acheiverrank} mb-0`}>Chairperson </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Faculty - Economics
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                     (Optional & General Studies) PhD
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      (Health Economics) from IIT Madras
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={chandraSekar}
                      alt="Mr. Chandrasekar S"
                      className="img-fluid"
                      title=" Mr. Chandrasekar S"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mr. Chandrasekar S
                    </p>
                    <p className={`${styles.acheiverrank} mb-0`}>
                      Head - Academics
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Faculty - International Organisation (General Studies)
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={shivashankarp}
                      alt="Mr. P Shivashankar"
                      className="img-fluid"
                      title="Mr. P Shivashankar"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mr. P Shivashankar
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Faculty - Social Issue (General Studies)
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={RajithaShivashankar1}
                      alt="Ms. Rajitha Shivashankar"
                      className="img-fluid"
                      title="Ms. Rajitha Shivashankar"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Ms. Rajitha Shivashankar
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Faculty - Sociology (Optional) and Society (General
                      Studies)
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={Sakthya}
                      alt="Mr. Sakthya Krishnan"
                      className="img-fluid"
                      title="Mr. Sakthya Krishnan"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mr. Sakthya Krishnan
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Faculty - Polity (General Studies)
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={KMPathi}
                      alt="Mr. K M Pathi"
                      className="img-fluid"
                      title="Mr. K M Pathi"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mr. K M Pathi
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Faculty - Ethics, Integrity & Aptitude (General Studies)
                      Visiting faculty to Central (LBSNAA) & State
                      Administrative Training Institutes.
                    </p>
                  </div>
                </div>
              </div>


              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={Dnilango}
                      alt="Mr. K M Pathi"
                      className="img-fluid"
                      title="Mr. K M Pathi"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Dr. N. Ilango
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                    Faculty - Tamil optional  
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={GaneshVK1}
                      alt="Mr. Ganesh V K"
                      className="img-fluid"
                      title="Mr. Ganesh V K"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mr. Ganesh V K
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Faculty - History (General Studies)
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={ManikandanSR1}
                      alt="Mr. Manikandan S R"
                      className="img-fluid"
                      title="Mr. Manikandan S R"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mr. Manikandan S R
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Faculty - General Economics (General Studies)
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={Govindaraju1}
                      alt="Mr. Govindaraju R"
                      className="img-fluid"
                      title="Mr. Govindaraju R"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mr. Govindaraju R
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Faculty - Political Science (Optional) and Bilateral
                      Relations (General Studies)
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={SaravanaMoorthy1}
                      alt="Mr. Saravanamoorthy P"
                      className="img-fluid"
                      title="Mr. Saravanamoorthy P"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mr. Saravanamoorthy P
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Faculty - History <br/> (Optional and General Studies)
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={vijayprofile}
                      alt="Mr. Vijay"
                      className="img-fluid"
                      title="Mr. Vijay"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mr. Vijay
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Faculty - Psychology  <br/>(Optional) and Environment (General
                      Studies)
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={Gowtham}
                      alt="Mr. Gowtham A R"
                      className="img-fluid"
                      title="Mr. Gowtham A R"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mr. Gowtham A R
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Faculty - Geography  <br/>(Optional and General Studies)
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={Mowshmikka}
                      alt="Mrs. Mowshimkka Renganathan (PhD candidate)"
                      className="img-fluid"
                      title="Mrs. Mowshimkka Renganathan (PhD candidate)"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mrs. Mowshimkka Renganathan,
                    </p>
                    <p className={`${styles.acheivername} mb-0`}>
                      (PhD candidate)
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Faculty - Anthropology (Optional)
                    </p>
                  </div>
                </div>
              </div>


              

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={DArunKumar1}
                      alt="Mr. Arunkumar D"
                      className="img-fluid"
                      title="Mr. Arunkumar D"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mr. Arunkumar D
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Faculty - Public Administration (Optional) and Governance
                      (General Studies)
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={SobhanGeorge}
                      alt="Mr. Sobhan George Abraham"
                      className="img-fluid"
                      title="Mr. Sobhan George Abraham"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`} style={{whiteSpace:"nowrap"}}>
                      Mr. Sobhan George Abraham
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Faculty - History <br/>(Optional and General Studies)
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={KarthikeyanS}
                      alt="Mr Karthikeyan S"
                      className="img-fluid"
                      title="Mr Karthikeyan S"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mr Karthikeyan S
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Faculty - Law Optional & Polity
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={Kanagaraj}
                      alt="Mr. Kanagaraj"
                      className="img-fluid"
                      title="Mr. Kanagaraj"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mr. Kanagaraj
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Faculty - Agriculture (Optional)
                    </p>
                  </div>
                </div>
              </div>

              {/* <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={profileplaceholder}
                      alt="Ms. Fathima"
                      className="img-fluid"
                      title="Ms. Fathima"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Ms. Fathima
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Faculty - CSAT (Reasoning)
                    </p>
                  </div>
                </div>
              </div> */}
              
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={eshwar}
                      alt="Mr.Eswar"
                      className="img-fluid"
                      title="Mr.Eswar"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mr.Eswar
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Faculty - CSAT
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={venkataramanan}
                      alt="Mr. Venkataramanan S"
                      className="img-fluid"
                      title="Mr. Venkataramanan S"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                    Mr. Venkataramanan S
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                    Faculty - CSAT
                    </p>
                  </div>
                </div>
              </div>

              

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={Elanchezhiyan}
                      alt="Mr.Elanchezhiyan "
                      className="img-fluid"
                      title="Mr. Elanchezhiyan "
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                    Mr. Elanchezhiyan 
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                    Faculty -CSAT
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={VittalReddy}
                      alt="Mr. Vittal Reddy"
                      className="img-fluid"
                      title="Mr. Vittal Reddy"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mr. Vittal Reddy
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Faculty - Optional (Mathematics)
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={Sarath}
                      alt="Mr. Sarath R"
                      className="img-fluid"
                      title="Mr. Sarath R"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mr. Sarath R
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Faculty - Economics  <br/>(Optional and General Studies)
                    </p>
                  </div>
                </div>
              </div>

              

              {/* <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={ashnajoy1}
                      alt="Ms. Ashna Joy"
                      className="img-fluid"
                      title="Ms. Ashna Joy"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Ms. Ashna Joy
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Faculty - Internal Security (General Studies) Pursuing PhD
                      in Indo-China relations IIT Madras
                    </p>
                  </div>
                </div>
              </div> */}

              

              


              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={ArjunRadhakrishnan}
                      alt="Mr. Arjun Radhakrishnan"
                      className="img-fluid"
                      title="Mr. Arjun Radhakrishnan"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mr. Arjun Radhakrishnan
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Faculty - (Public Administration & Current Affairs)
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={rajkumarsp}
                      alt="Mr.Rajkumar SP"
                      className="img-fluid"
                      title="Mr.Rajkumar SP"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mr.Rajkumar SP
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Faculty - Internal Security, polity Optional - Political
                      science.
                    </p>
                  </div>
                </div>
              </div>

              
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={JohnMajel}
                      alt="Mr.John Majel "
                      className="img-fluid"
                      title="Mr. John Majel "
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                    Mr. John Majel 
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                    Faculty - English (Optional) 
                    </p>
                  </div>
                </div>
              </div>

             

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={premanand}
                      alt="Mr. Premanand"
                      className="img-fluid"
                      title="Mr. Premanand"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mr. Premanand
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Faculty - Indian Polity (General Studies) Political
                      Science - Optional Subject
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={Chandramohan}
                      alt="Mr.Chandramohan"
                      className="img-fluid"
                      title="Mr.Chandramohan"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mr.Chandramohan
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Faculty - Current Affairs
                    </p>
                  </div>
                </div>
              </div>

              
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={sucharithan}
                      alt="Mr.N.Sucharithan"
                      className="img-fluid"
                      title="Mr.N.Sucharithan"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mr.N.Sucharithan
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Faculty - Science and Technology(General Studies)
                    </p>
                  </div>
                </div>
              </div>

              

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={NithyaSelvakumar}
                      alt="Mrs. Nithya K"
                      className="img-fluid"
                      title="Mrs. Nithya K"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mrs. Nithya K
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Faculty - Polity and Governance
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={SivaChidambaram}
                      alt=" Mr. Siva Chidambaram T"
                      className="img-fluid"
                      title="Mr. Siva Chidambaram T"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mr. Siva Chidambaram T
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Faculty - Geography
                    </p>
                  </div>
                </div>
              </div>

              {/* <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={apoorva}
                      alt="Miss. Apoorva M"
                      className="img-fluid"
                      title="Miss. Apoorva M"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Miss. Apoorva M
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Faculty - Society in India.
                    </p>
                  </div>
                </div>
              </div> */}


             

             {/* <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={shahnawaz}
                      alt="Mr. Shahnawaz"
                      className="img-fluid"
                      title="Mr. Shahnawaz"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                    Mr. Shahnawaz
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                    Faculty - Polity
                    </p>
                  </div>
                </div>
              </div> */}

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={Mukuljha}
                      alt="Mr. Mukul Jha"
                      className="img-fluid"
                      title="Mr. Mukul Jha"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                    Mr. Mukul Jha
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                    Faculty - Economics
                    </p>
                  </div>
                </div>
              </div>

             {/*  <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={Ruchir}
                      alt="Mr. Ruchir Kumar"
                      className="img-fluid"
                      title="Mr. Ruchir Kumar"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                    Mr. Ruchir Kumar
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                    Faculty - General Studies (Geography)
                    </p>
                  </div>
                </div>
              </div>

            <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={Alokkumar}
                      alt="Mr. Alok Kumar Pathak"
                      className="img-fluid"
                      title="Mr. Alok Kumar Pathak"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                    Mr. Alok Kumar Pathak
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                    Faculty - General Studies  <br/>(Science & Tech/Polity)
                    </p>
                  </div>
                </div>
              </div>*/}

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={KarthikeyanP}
                      alt="Mr. Karthikeyan P"
                      className="img-fluid"
                      title="Mr. Karthikeyan P"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                    Mr. Karthikeyan P
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                    Faculty -Polity<br/> (General Studies) 
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={AbuMathew}
                      alt="Mr. Abu Mathew"
                      className="img-fluid"
                      title="Mr. Abu Mathew"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                    Mr. Abu Mathew
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                    Faculty - Geography <br/>(General Studies)
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={AkkemSomasekhar}
                      alt="Mr. Akkem Somasekhar"
                      className="img-fluid"
                      title="Mr. Akkem Somasekhar"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                    Mr. Akkem Somasekhar
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                    Faculty - History<br/>  ( General Studies)
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={ Arunkumar}
                      alt="Mr.  Arun kumar"
                      className="img-fluid"
                      title="Mr.  Arun kumar"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                    Mr. Arun kumar
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                    Faculty -Geography<br/> (General Studies) 
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={ Ganeshkumar}
                      alt="Mr. Ganesh kumar"
                      className="img-fluid"
                      title="Mr. Ganesh kumar"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                    Mr. Ganesh kumar
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                    Faculty -Economics<br/> (General Studies) 
                    </p>
                  </div>
                </div>
              </div>

              

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={SammratBhaskar}
                      alt="Mr. Sammrat Bhaskar"
                      className="img-fluid"
                      title="Mr. Sammrat Bhaskar"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                    Mr. Sammrat Bhaskar
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                    Faculty -Society in India<br/> (General Studies) 
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={Vishnu}
                      alt="Mr. Vishnu "
                      className="img-fluid"
                      title="Mr. Vishnu "
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                    Mr. Vishnu 
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                    Faculty - Geography<br/> (General Studies) 
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={Anusha}
                      alt="Mrs. Anusha"
                      className="img-fluid"
                      title="Mrs. Anusha"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                    Mrs. Anusha
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                    Faculty - History<br/> (General Studies) 
                    </p>
                  </div>
                </div>
              </div>

              
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={Vishwas}
                      alt="Mr. Vishwas "
                      className="img-fluid"
                      title="Mr. Vishwas "
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                    Mr. Vishwas 
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                    Faculty - Current Affairs<br/> (General Studies) 
                    </p>
                  </div>
                </div>
              </div>

   <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={Sandeep}
                      alt="Mr. Sandeep Ready "
                      className="img-fluid"
                      title="Mr. Sandeep Ready "
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                    Mr. Sandeep Reddy 
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                    Faculty - GS Economics and Economics Optiona 
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

      <Footer />
    </>
  );
};

export default Faculty;
